import React from "react";

const ImageList = ({ files, onDelete, onImageClick }) => {
  return (
    <div className="media-gallery">
      <h3>🖼 Images</h3>
      <div className="media-grid">
        {files.length === 0 ? (
          <p>No images found.</p>
        ) : (
          files.map(file => (
            <div key={file.id} className="media-item">
              <img 
                src={file.url} 
                alt={file.name} 
                className="media-thumbnail" 
                onClick={() => onImageClick(file)}  // Open in lightbox
              />
              <p>{file.name}</p>
              <button onClick={() => onDelete(file.name)}>🗑</button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ImageList;
